import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '../SvgIcon';
import { Tooltip } from '../Tooltip';
import circleInfoBackgroundLightIcon from '@/core/svg/fa/circle-info-background-light.svg';
import { forwardRef } from 'react';
import { Box } from '../muiReexports';
const TooltipIconHelper = forwardRef(({ iconSize, withFormLabel, ...props }, ref) => {
    return (_jsx(Tooltip, { ...props, ref: ref, arrow: true, slotProps: { tooltip: { style: { lineHeight: '1.25rem' } } }, children: _jsx(Box, { sx: ({ spacing }) => ({ display: 'flex', alignItems: 'center', marginBottom: withFormLabel ? spacing(1) : 0 }), children: _jsx(SvgIcon, { icon: circleInfoBackgroundLightIcon, size: iconSize ?? 'md' }) }) }));
});
export { TooltipIconHelper };
